module.exports = __webpack_public_path__ + "img/course-1-4.4e3018ee.jpeg";